export const enum Status {
  tagging = "Tagging",
  completed = "Completed",
  error = "Error",
}

export const enum TaggingStatus {
  processing = "Processing",
  processed = "Processed",
  uploaded = "Uploaded",
  failed = "Failed",
}
